import { createSlice } from '@reduxjs/toolkit'
import IAuthentication from '../../../../interface/core/IAuthentication'
import { sliceStateStatus } from '../../../../Core';

import {
    resetAuthData,
    setAuthData,
    logout,
    login,
    me,
    resetAuthentication,
    forgotPassword,
    resetPassword
} from './authenticationActions'

import axios from 'axios';
import ISliceState from '../../../../interface/core/ISliceState'
import { routesIndex } from '@/RoutesIndex';
import { AppDispatch } from '../../../store';

/*const initialState: IAuthData = {
  isAuthenticated: false,
  loginData: {
    email: '',
    password: ''
  },
  userData: {
      id: 0,
      name: '',
      surname: '',
      mobile: '',
      role: '',
      email: ''
  }
}*/

export const checkSession = () => async (dispatch: AppDispatch) => {
  try {
    await dispatch(me()).unwrap() 
  } catch (err) {
    dispatch(resetAuthentication())
  }
}

const initialState: ISliceState = {
  data: {
    isAuthenticated: false,
    login: {
      email: '',
      password: ''
    },
    user: {
      id: 0,
      name: '',
      surname: '',
      mobile: '',
      role: '',
      email: ''
    }
  } as IAuthentication,

  status: sliceStateStatus.idle
};

const authenticationSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {
   /*setAuthData(state, action: PayloadAction<IAuthData>) {

      //console.log('reduxtoolkit: setFormData:');
      //console.log(action.payload);

      //state = action.payload

      console.log('reduxtoolkit: action.payload:');
      console.log(action.payload);

      return action.payload
    },
    resetAuthData(state, action: PayloadAction<IAuthData>) {
      return initialState
    }*/
  },
  extraReducers: (builder) => {
    builder
        .addCase(setAuthData, (state, action) => {
          Object.assign(state, action.payload);
        })
        .addCase(resetAuthData, (state, action) => {return initialState;})

    builder
        .addCase(login.fulfilled, (state, action) => {
            //console.log('login');
            //console.log(action);

            //state = action.payload;
            //setAuthData(action.payload);
            //Object.assign(state, action.payload);
            
            //return action.payload;
        })
        .addCase(login.pending, (state, action) => {
          state.status = sliceStateStatus.pending;
          return state;
        })
        .addCase(login.rejected, (state, action) => {
          state.status = sliceStateStatus.rejected;
          return state;
        })
        
        .addCase(me.fulfilled, (state, action) => {
            //console.log('login');
            //console.log(action);

            //state = action.payload;
            //setAuthData(action.payload);
            //Object.assign(state, action.payload);
            return action.payload;
        })
        .addCase(me.pending, (state, action) => {
          state.status = sliceStateStatus.pending;
          return state;
        })
        .addCase(me.rejected, (state, action) => {
          state.status = sliceStateStatus.rejected;
          return state;
        })
        


        /*.addCase(logout.fulfilled, (state, action) => {
          console.log('logout');
          console.log(action.payload);

          //state = action.payload;
          //setAuthData(action.payload);
          //Object.assign(state, action.payload);
          return initialState;
        })
        .addCase(logout.rejected, (state, action) => {

          console.log('logout.rejected');
          console.log(action.error);

          return state;
        })*/
        .addCase(logout, (state, action) => {

          const config = {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
          }

          axios.post(routesIndex.api.authentication.logout, {}, config);
          return initialState;
        })
        .addCase(resetAuthentication, (state, action) => {
          return initialState;
        })
        
        .addCase(forgotPassword.fulfilled, (state, action) => {
          return action.payload;
        })
        .addCase(forgotPassword.pending, (state, action) => {
          state.status = sliceStateStatus.pending;
          return state;
        })
        .addCase(forgotPassword.rejected, (state, action) => {
          state.status = sliceStateStatus.rejected;
          return state;
        })
        .addCase(resetPassword.fulfilled, (state, action) => {
          return action.payload;
        })
        .addCase(resetPassword.pending, (state, action) => {
          state.status = sliceStateStatus.pending;
          return state;
        })
        .addCase(resetPassword.rejected, (state, action) => {
          state.status = sliceStateStatus.rejected;
          return state;
        })
  }
})

export default authenticationSlice.reducer
